export default {
      id: "square-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svgsprite.svg#square",
      toString: function () {
        return this.url;
      }
    }